export default __webpack_public_path__ + "static/media/icon1.8c480b85.svg";